// plan-04 S01: v1 slot pools (verbatim) + new Oracle-framing pools — bible S20

export const SLOT_X: string[] = [
  "Everything", "Nothing", "The answer", "A path", "What you seek",
  "The truth", "Time", "The thing", "Someone", "The target",
  "The only thing that matters", "Despite everything, it", "He who checks the window",
  "A great, happy tear", "The circumstance", "A loaded gun",
  "The danger", "A good thing", "Oddly enough, all", "A beautiful waterfall",
  "The win", "Ol' Red Bird", "A call to arms",
]

export const SLOT_Y: string[] = [
  "is closer than you think", "has already been decided", "will reveal itself",
  "was never hidden", "is waiting for you", "is beyond this moment",
  "was always yours to find", "cannot be undone", "has always been open",
  "is already in motion", "resides here", "should be clear by now",
  "shall pass", "will be shed", "is worth dying for",
]

export const SLOT_Z: string[] = [
  "it's not up to", "no one will tell", "it doesn't involve",
  "it won't wait for", "it never needed", "it won't wait for",
  "it has never required", "it will pass through", "good news for",
  "the scariest of all is", "many won't understand", "forgiveness is for",
  "it will congratulate", "slowly clapping for", "they will remember",
  "make sure to always understand the importance of", "read the Talmud for",
  "bend over for", "it stimulates", "the fault is not alone, it's just in",
  "folly, they congregate within", "tears were shed for", "noone will remember",
  "they're all thinking about", "cheering for", "time to dance for",
]

export const SLOT_A: string[] = [
  "you", "them", "anyone", "chance", "effort", "time", "belief",
  "permission", "understanding", "anyone at all", "many", "this", "hotdog", "itself", "anyone who will listen",
  "those who can't", "great minds", "a new essence", "the smirking cretin", "the Samson Option", "the sake of it",
]

export const SLOT_PROBABLY: string[] = [
  "probably.",
  "consensus pending.",
  "proposer: null.",
  "quorum: probably.",
  "router: unresolved.",
  "vote state: probably.",
  "the pattern is always the same. until it isn't.",
  "observation: continuous.",
  "drift: nominal.",
  "signal: present.",
  "the oracle does not repeat itself. probably.",
  "this has been noted.",
]

export const SLOT_QUORUM: string[] = [
  "48 of 48",
  "48 of 49",
  "47 of 48 — drift -1",
  "consensus: probably",
  "awaiting proposer",
  "proposer: null. quorum: 48.",
  "quorum: 48. drift: 0.",
  "all nodes. PROBABLY.",
  "full quorum. no dissent.",
  "48 channels. all open.",
]
